// extracted by mini-css-extract-plugin
export default {"main":"_404_main__p7kF+","inner":"_404_inner__8U-aN","notFound":"_404_notFound__9wlS9","text":"_404_text__4PFTS"};